<template>
  <div class="history">
    <div class="header">History Outbound</div>
    <div class="report">
      <div
        class="lead-history-report-row"
        :class="{ header: index === 0 }"
        v-for="(leadHome, index) in leadHomeReportHistoryPresenters"
        :key="index"
      >
        <div class="report-cell center">
          {{ leadHome.contactDate }}
        </div>
        <div class="report-cell">
          {{ leadHome.projectName }}
        </div>
        <div class="report-cell center">
          {{ leadHome.houseNo }}
        </div>
        <div class="report-cell">
          {{ leadHome.customerName }}
        </div>
        <div class="report-cell">
          {{ leadHome.mobileNo }}
        </div>
        <div class="report-cell">
          {{ leadHome.name }}
        </div>
        <div class="report-cell center">
          <div v-if="index === 0">
            {{ leadHome.statusLabel }}
          </div>
          <div
            v-else
            class="lead-status-badge center"
            :class="leadHome.statusValue"
          >
            {{ leadHome.statusLabel }}
          </div>
        </div>
        <div class="report-cell">
          {{ leadHome.reason }}
        </div>
        <div class="report-cell">
          {{ leadHome.remark }}
        </div>
        <div class="report-cell">
          {{ leadHome.contactBy }}
        </div>
        <div class="report-cell">
          {{ leadHome.package }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies";
import { toCamelCaseObject } from "@/lib/util";
import { convertDateTimeToTimeText } from "@/lib/dateTime";
import {
  leadHomeStatusMapper,
  leadManagementReason
 } from "@/lib/mapper";

export default {
  name: "LeadContactHistoryReport",
  computed: {
    leadHomeReportHistoryPresenters() {
      const header = {
        contactDate: "วันที่ติดต่อ",
        projectName: "โครงการ",
        houseNo: "บ้านเลขที่",
        customerName: "ชื่อลูกค้า",
        mobileNo: "เบอร์โทร",
        name: "ชื่อ Lead",
        statusLabel: "สถานะการขาย",
        reason: "เหตุผล",
        remark: "หมายเหตุ",
        contactBy: "ผู้รับผิดชอบการขาย",
        package: "แพ็คเกจ"
      };

      return [header, ...this.contactHistories];
    },
  },
  data() {
    return {
      contactHistories: [],
    };
  },
  props: {
    homeId: {
      type: String
    },
    leadHomeStatus: {
      type: Object
    }
  },
  watch: {
    async homeId() {
      await this.setupData();
    }
  },
  created() {
  },
  methods: {
    setup() {
      this.setupData();
    },
    async setupData() {
      await this.setupContactHistories();
    },
    async setupContactHistories() {
      const result = await this.fetchContactHistories();

      this.contactHistories = toCamelCaseObject(result.history_list).map(
        (history) => {
          const status = leadHomeStatusMapper.find(
            (status) => status.value === history.status
          )

          const statusLabel = status && status.label
            ? status.label
            : "ไม่มี สถานะ"

          const statusValue = status && status.value
          ? status.value
          : "UNKNOW"

          const reason = history.reason
          ? leadManagementReason.find(i => i.value === history.reason).label
          : null;

          return {
            ...history,
            customerName: `${history.firstName} ${history.lastName}`,
            contactDate: convertDateTimeToTimeText(history.contactDate, "dd MMM yyyy"),
            statusLabel,
            statusValue,
            reason
          }
        }
      );
    },
    async fetchContactHistories() {
      if (!this.homeId) {
        return (this.contactHistories = []);
      }

      try {
        const response = await baanRueJaiClient.admin.lead.getHomeContactHistoryList(
          this.homeId
        );

        return response.data.result;
      } catch (error) {
        throw error;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
@import "../lead";

.lead-history-report-row {
  display: grid;
  grid-template-columns:
    100px
    200px
    80px
    150px
    100px
    100px
    100px
    120px
    150px
    200px
    250px
}

.lead-history-report-row:first-child {
  position: sticky;
  top: 0;

  .report-cell {
    border-top: 1px solid #444;
    font-weight: bold;
    background: #ddd;
  }
}

.report-cell {
  font-size: 14px;
  padding: 10px;
}

.center {
  text-align: center;
}

.header {
  font-weight: bold;
  font-size: 22px;
}

</style>


// WEBPACK FOOTER //
// src/features/lead-management/component/LeadContactHistoryReport.vue